import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import { ICommonValue } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {

  _baseUrl = 'api/v1/common/';

  cache = new Map<string, Observable<ICommonValue[]>>();

  constructor(protected authHttp: HttpClient) {
  }

  getMenu(): Observable<any> {
    return this.authHttp.get(this._baseUrl + 'menu');
  }

  getUrlData(url: string): Observable<any[]> {
    return this.authHttp
      .get(url).pipe(
        map(r => r as any[])
      );
  }
}
